define('widgets/dataGrid/viewmodel',['plugins/widget', 'durandal/composition', 'jquery', 'knockout', 'services/trace', 'models/event', 'widgets/dataGrid/model'],
function (widget, composition, $, ko, trace, event, model) {
	var ctor = function () { };

	ctor.prototype.kendoColumns = function () {
		return this.createKendoColumns(this.settings.columnDefinitions);
	};

	ctor.prototype.enableDragAndDrop = function () {
	    if (!this.settings.dragAndDrop) {
	        return;
        }

        setTimeout(function () {
            var grid = $('.k-grid');

            grid.find('tbody').css('cursor', 'pointer');

            grid.kendoDraggable({
                filter: "tbody tr",
                cursorOffset: { top: 0, left:0 },
                dragstart: function(element) {
                    element.currentTarget.addClass('move-message-active-source');
                    $('body').css('cursor', 'pointer').addClass('body-drag-start');
                },
                dragend: function(element) {
                    element.currentTarget.removeClass('move-message-active-source');
                    $('body').css('cursor', 'default').removeClass('body-drag-start');
                },
                hint: function(element) {
                    var messageSubject = element.data('subject');
                    var draggableObject = '<div class="move-message-hint-container">' +
                        '<div><i class="fa fa-envelope"></i></div>' +
                        '<div>' + messageSubject + '</div>' +
                        '</div>';

                    return draggableObject;
                }
            });
        }, 0);
    };

	ctor.prototype.fullSelectionState = ko.computed(function() {
		return false;
	});

	ctor.prototype.activate = function (settings) {
		var that = this;

		this.settings = settings;
		if (this.settings.groupable === undefined) this.settings.groupable = false;

		this.createColumnDefinitions(settings);
	};

	ctor.prototype.attached = function (settings) {
		var that = this;

		if (this.loadedEvent == null) {
			this.loadedEvent = new event.EventHandler(function (sender, e) {
				var items = that.settings.selectedItems;
				if (items != null) {
					items.removeAll();
				}
			});

			this.settings.controller.onLoaded.add(this.loadedEvent);
		}
		}

	ctor.prototype.detached = function (settings) {
		if (this.loadedEvent != null) {
			this.settings.controller.onLoaded.remove(this.loadedEvent);
		}
	}

	var templateRenderer = function (id) {
		var that = this;
		return function (data) {
			return ko.renderTemplate(id, that.grid.context.createChildContext((data._raw && data._raw()) || data));
		};
	};

	ctor.prototype.controller = function () {
		return this.settings.controller;
	};

	ctor.prototype.createKendoColumns = function (columnsDef) {
		var result = [];
		var that = this;
		columnsDef.forEach(function (element) {
			var column = {};

			column.field = element.name;
			column.title = element.header;
			column.headerAttributes = element.headerAttributes;

			if (element.width !== undefined) column.width = element.width;
			if (element.sortable !== undefined) column.sortable = element.sortable;

			if (typeof element.rowValue == 'function') {
				column.template = element.rowValue;
			} else {
				column.template = element.template;
			}

			result.push(column);
		});
		return result;
	};

	ctor.prototype.createColumnDefinitions = function (settings) {
		var definitions = [];

		settings.columns.forEach(function (element) {
			var column = new model.GridColumn();

			column.headerText = element.headerText;
			column.i18n = element.i18n;
			column.name = column.rowValue = element.name;
			column.headerAttributes = element.headerAttributes;

			if (element.rowValue !== undefined) column.rowValue = element.rowValue;
			if (element.sortable !== undefined) column.sortable = element.sortable;
			if (element.template !== undefined) column.template = element.template;
			if (element.canSelectAll !== undefined) column.canSelectAll = element.canSelectAll;
			if (element.sort !== undefined) column.sortDirection(element.sort);
			if (element.width !== undefined) column.width = element.width;

			definitions.push(column);
		});

		this.settings.columnDefinitions = definitions;
	};

	ctor.prototype.setSelection = function() {
		var value = !this.fullSelectionState();
		var controller = this.settings.controller;
		var data = controller.result();

		if (this.settings.selectedItems === undefined) {
			setTimeout(function () {
				Enumerable.From(data)
					.ForEach(function (d) {
						d.isSelected = value;
					});
			});
		} else {
			var selectedItems = this.settings.selectedItems;
			setTimeout(function () {
				selectedItems.removeAll();
				if (value) {
					Enumerable.From(data)
						.ForEach(function (d) {
							selectedItems.push(d);
						});
				}
			});
		}
	};

	ctor.prototype.getSelectedItems = function () {
		if (this.settings.selectedItems === undefined) {
			return Enumerable.From(this.settings.controller.result())
				.Where(function(d) { return d.isSelected == true; })
				.ToArray();
		} else {
			return this.settings.selectedItems();
		}
	}



	return ctor;
});
